module.exports = __webpack_public_path__ + "static/previa-26c45cbfdc2522ffd2cba6fa29b28186.gif";